{
  "FRONTEND": {
    "CORE": {
      "SHARED": {
        "DISPLAY_PRICE": {
          "CONTACT_SALES": "Contact Sales",
          "PRICE_CURRENCY_EXC_VAT": "{{price}} {{currencySymbol}} exc. VAT",
          "FREE": "Free",
          "STARTING_AT_PRICE": "Starting at {{price}}",
          "SETUP_FEE": "Setup fee",
          "PRICING_FREQUENCIES": {
            "OTHER": "Other",
            "ONE_TIME": "One Time",
            "DAILY": "Daily",
            "WEEKLY": "Weekly",
            "MONTH": "month",
            "MONTHLY": "Monthly",
            "YEAR": "year",
            "YEARLY": "Yearly"
          }
        }
      }
    }
  }
}
